import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
  Grid,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

export const ApplicantOrganisationDetails: React.FC<{
  isExpanded: boolean;
  toggleExpand: () => void;
  data: any;
}> = ({ isExpanded, toggleExpand, data }) => {
  const org = data?.organizations?.[0] || {};

  const orgDetails = [
    { label: "Business Name", value: org.business_name || "-" },
    { label: "Entity Type", value: org.entity_type || "-" },
    { label: "Nature of Business", value: org.business_nature || "-" },
    // { label: "PAN Card No", value: org.pan_number || "-" },
    { label: "Registration Date", value: org.registration_date || "-" },
    {
      label: "Address",
      value: org.address
        ? org.address
        : [
            org.address_line1,
            org.address_line2,
            org.city_name,
            org.district_name,
            org.state_name,
            org.pincode,
          ]
            .filter(Boolean)
            .join(", ") || "-",
    },
    { label: "Pin Code", value: org.pincode || "-" },
    { label: "CIN No", value: org.cin || "-" },
    { label: "TIN No", value: org.tin || "-" },
    { label: "GST No", value: org.gst_number || "-" },
  ];

  const orgdetailsLayout = [
    [orgDetails[0], orgDetails[1]],
    [orgDetails[2], orgDetails[3]],
    [orgDetails[4], orgDetails[5]],
    [orgDetails[6], orgDetails[7]],
    [orgDetails[8]],
  ];
  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <Card sx={{ boxShadow: "none", border: "1px solid #E7E8E9" }}>
        {/* Header */}
        <Box
          sx={{
            backgroundColor: "#F4F2F7",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #E7E8E9",
            pl: 2,
            py: "5px",
          }}
        >
          <Typography
            sx={{ fontSize: 12 }}
            fontWeight="semi-bold"
            className="preview-dropdown-header"
          >
            Applicant Organisation Details
          </Typography>
          <IconButton aria-label="Collapse section" onClick={toggleExpand}>
            {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </Box>

        {/* Content */}
        {isExpanded && ( // Conditionally render the content
          <CardContent>
            <Grid container spacing={4} justifyContent="center">
              <Grid item xs={12} spacing={1}>
                <Box
                  sx={{
                    display: { xs: "block", sm: "flex" },
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  {orgdetailsLayout.map((row, rowIndex) => (
                    <Box
                      key={`row-${rowIndex}`}
                      sx={{
                        display: { xs: "block", sm: "flex" },
                        justifyContent: "space-between",
                        gap: 4,
                      }}
                    >
                      {row.map((detail, colIndex) => (
                        <Box
                          key={`detail-${rowIndex}-${colIndex}`}
                          sx={{ flex: 1 }}
                        >
                          <Typography
                            className="preview-dropdown-label"
                            sx={{
                              fontWeight: "500",
                              mb: 0.5,
                              color: "#878787",
                            }}
                          >
                            {detail.label}
                          </Typography>
                          <Typography
                            sx={{ fontSize: "1rem" }}
                            className="preview-dropdown-value"
                          >
                            {detail.value}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  ))}
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        )}
      </Card>
    </Box>
  );
};
